"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIframeStyles = createIframeStyles;
function createIframeStyles(styles = {}) {
    return {
        display: 'block',
        background: `${styles.background ?? 'white'}`,
        ...(styles.width && { width: `${styles.width}px` }),
        ...(styles.height && { height: `${styles.height}px` }),
        ...((styles.borderRadius || styles.borderRadius === 0) && {
            borderRadius: `${styles.borderRadius}px`,
        }),
    };
}
